module.exports = __webpack_public_path__ + "img/dr_1.bb5a7cd9.png";